import { Controller } from "@hotwired/stimulus"

// Generic Rails nested-attributes add/remove for one collection. "add" clones
// this instance's <template> (swapping its placeholder for a unique index) and
// appends it to the list; "remove" flags the row's _destroy field and hides it
// (persisted rows are kept-but-destroyed; brand-new rows with _destroy set are
// simply ignored on save). Nest two instances — add-ons (placeholder NEW_ADDON)
// wrapping tiers (placeholder NEW_TIER) — and Stimulus scopes targets to the
// nearest controller, so each manages only its own rows.
export default class extends Controller {
  static targets = ["list", "template"]
  static values = { placeholder: { type: String, default: "NEW_RECORD" } }

  add(event) {
    event.preventDefault()
    const index = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const html = this.templateTarget.innerHTML.replaceAll(this.placeholderValue, index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-form-row]")
    if (!row) return

    const destroy = row.querySelector("input[data-destroy-flag]")
    if (destroy) destroy.value = "1"
    row.classList.add("d-none")
  }
}
